import * as url from "../../helpers/url_helper";
import { apiCall, fetchApi } from "./apiService";

/**
 * Loads blocked coupons for a store
 * @param {string} storeDomain - Store domain
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Blocked coupons data or null if error
 */
export const loadBlockedCoupons = async (storeDomain, notifyError) => {
    try {
        const endpoint = `${url.BLOCKED_COUPON}?store=${encodeURIComponent(storeDomain)}`;
        const { response, results } = await fetchApi(endpoint, 'GET');

        if (response.ok && results?.data) {
            return results.data;
        }
        return null;
    } catch (error) {
        if (notifyError) {
            notifyError("Failed to load blocked coupons");
        }
        return null;
    }
};

/**
 * Adds a blocked coupon
 * @param {string} storeDomain - Store domain
 * @param {string} coupon - Coupon code to block
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const addBlockedCoupon = async (storeDomain, coupon, notifyError) => {
    return await apiCall(
        url.BLOCKED_COUPON,
        'POST',
        {
            store: storeDomain,
            coupons: [coupon]
        },
        notifyError,
        "Failed to add blocked coupon"
    );
};

/**
 * Deletes a blocked coupon
 * @param {string} storeDomain - Store domain
 * @param {string} coupon - Coupon code to delete
 * @param {Function} notifySuccess - Success notification function
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const deleteBlockedCoupon = async (storeDomain, coupon, notifySuccess, notifyError) => {
    try {
        const { response, results } = await fetchApi(url.BLOCKED_COUPON, 'DELETE', {
            coupon,
            store: storeDomain
        });

        if (response.ok) {
            if (notifySuccess) {
                notifySuccess("Blocked coupon has been deleted successfully");
            }
            return true;
        } else {
            if (notifyError) {
                notifyError("Blocked coupon could not delete!");
            }
            return false;
        }
    } catch (error) {
        if (notifyError) {
            notifyError("Blocked coupon could not delete!");
        }
        return false;
    }
};

/**
 * Updates coupon eligibility for a store
 * @param {string} storeDomain - Store domain
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateCouponEligibility = async (storeDomain, notifyError) => {
    return await apiCall(
        url.COUPON_ELIGIBILITY,
        'PUT',
        {
            store: storeDomain
        },
        notifyError,
        "Failed to update coupon eligibility"
    );
};

